export default "__VITE_ASSET__BLCcF$NE__"